// @ts-nocheck
import { label } from './lib/labels';
import { statusLabel, statusTone } from './lib/status';
import Badge from './ui/Badge';
import Toggle from './ui/Toggle';

const FEATURES = [
  ['whatsapp', 'WhatsApp'],
  ['web', 'Website chat'],
  ['tiktok', 'TikTok'],
  ['comment_automation', 'Comment replies'],
  ['followup_enabled', 'Smart Follow-up'],
  ['faq_enabled', 'Ready answers'],
  ['owner_copilot', 'Owner Copilot'],
  ['customer_ai', 'Customer AI'],
  ['instagram_dm', 'Instagram DM'],
  ['facebook_dm', 'Facebook DM'],
  ['content_management', 'Content management'],
];

/**
 * One paid plan: caps and feature toggles in a single card.
 * @param {{ plan: any, draft: any, onChange: (next: any) => void }} props
 */
export default function PaidPlanEditor({ plan, draft, onChange }) {
  const id = plan.plan_id;
  const row = draft[id] || {};

  function setField(field, value) {
    onChange({ ...draft, [id]: { ...row, [field]: value } });
  }

  return (
    <div className="mt-6 rounded-xl border border-slate-200 p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-sm font-semibold text-slate-900">{label('plan', id)}</h3>
        <Badge tone={statusTone('planLive', plan.checkout_ready)}>{statusLabel('planLive', plan.checkout_ready)}</Badge>
      </div>
      <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        <label className="text-sm">Price (USD / month)
          <input aria-label={`${id} price`} className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3 text-right" value={row.intended_price_usd ?? ''} onChange={(event) => setField('intended_price_usd', event.target.value)} />
        </label>
        <label className="text-sm">Messages included per month
          <input aria-label={`${id} messages`} className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3 text-right" value={row.included_messages ?? ''} onChange={(event) => setField('included_messages', event.target.value)} />
        </label>
        <label className="text-sm">Ready-answer limit
          <input aria-label={`${id} ready answers`} className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3 text-right" value={row.faq_capacity ?? ''} onChange={(event) => setField('faq_capacity', event.target.value)} />
        </label>
        <div>
          <label className="text-sm">Included team users
            <input aria-label={`${id} included team users`} disabled={Boolean(row.included_team_unlimited)} className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3 text-right disabled:bg-slate-100" value={row.included_team_unlimited ? '' : (row.included_team_seats ?? '')} onChange={(event) => setField('included_team_seats', event.target.value)} />
          </label>
          <p className="mt-1 text-[13px] text-slate-600">Includes the owner. Extra users use the extra-seat price.</p>
          <div className="mt-2">
            <Toggle checked={Boolean(row.included_team_unlimited)} onChange={(next) => onChange({ ...draft, [id]: { ...row, included_team_unlimited: next, included_team_seats: next ? '' : (row.included_team_seats || 1) } })} label="Unlimited team users" />
          </div>
        </div>
      </div>
      <p className="mt-4 text-sm font-medium text-slate-800">Included features</p>
      <div className="mt-2 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map(([key, name]) => (
          <Toggle key={key} checked={Boolean(row[key])} onChange={(next) => setField(key, next)} label={name} />
        ))}
      </div>
    </div>
  );
}
